module.exports = __webpack_public_path__ + "assets/icon-hide.08ac749c.svg";